import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export const BlogPreview = () => {
  const { t } = useTranslation();
  const articles = t("blog.articles", { returnObjects: true });

  return (
    <section data-testid="blog-preview-section" className="py-24 lg:py-36 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: EASE }}
          className="max-w-2xl"
        >
          <p className="text-xs font-medium uppercase tracking-[0.25em] text-mint mb-4">{t("blog.kicker")}</p>
          <h2 className="font-display font-semibold tracking-tighter text-white text-3xl sm:text-4xl lg:text-5xl text-balance">
            {t("blog.title")}
          </h2>
          <p className="mt-4 text-base md:text-lg text-white/55">{t("blog.sub")}</p>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {articles.map((a, i) => (
            <motion.div
              key={a.slug}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.12, ease: EASE }}
            >
              <Link
                to={`/blog/${a.slug}`}
                data-testid={`blog-card-${a.slug}`}
                className="group flex flex-col h-full rounded-2xl border border-white/8 bg-card p-8 transition-colors duration-300 hover:border-mint/30"
              >
                <div className="flex items-center justify-between">
                  <span className="rounded-full bg-mint/10 border border-mint/20 px-3 py-1 text-[11px] font-medium text-mint">{a.tag}</span>
                  <ArrowUpRight className="w-4 h-4 text-white/30 transition-all duration-200 group-hover:text-mint group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
                </div>
                <h3 className="mt-6 font-display font-semibold text-white text-xl tracking-tight leading-snug">{a.title}</h3>
                <p className="mt-3 text-sm text-white/50 leading-relaxed flex-1">{a.excerpt}</p>
                <p className="mt-6 text-xs text-white/35">
                  {a.date} · {a.readTime}
                </p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
